module.exports = __webpack_public_path__ + "static/img/switch.33333987.svg";